import React from 'react';
import Loadable from 'react-loadable';
import MainLayout  from './layout/MainLayout';

function Loading() {
  return <div>Loading...</div>;
}

// const Application = Loadable({
//   loader: () => import('./modules/application/component/application'),
//   loading: Loading,
// });

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: MainLayout, allowedRoles: ['admin'] },
//  { path: '/application', exact: true, name: 'Application', component: Application, allowedRoles: ['admin'] },
];

export default routes;


